import { Link } from 'react-router-dom';
import PreFooter from './PreFooter';
import NewsletterBar from './NewsletterBar';
import { FacebookIcon, InstagramIcon, LinkedinIcon, XIcon } from './Icons';
import { mainLinks, siteInfo } from './siteInfo';
import { useNavData } from './useNavData';

const heading = 'mb-5 text-xs font-semibold uppercase tracking-[0.0625rem] text-ink';
const linkCls = 'block py-1.5 text-[0.9375rem] text-black transition-colors hover:text-brand-dark';

export default function Footer() {
  const { domains } = useNavData();
  const socials = [
    { href: siteInfo.socials.instagram, label: 'Instagram', Icon: InstagramIcon },
    { href: siteInfo.socials.x, label: 'X', Icon: XIcon },
    { href: siteInfo.socials.linkedin, label: 'LinkedIn', Icon: LinkedinIcon },
    { href: siteInfo.socials.facebook, label: 'Facebook', Icon: FacebookIcon },
  ];

  return (
    <div role="contentinfo">
      <PreFooter />
      <NewsletterBar />
      <div className="bg-surface pb-8 pt-16">
        <div className="site-container">
          <div className="grid gap-12 sm:grid-cols-2 lg:grid-cols-[1.3fr_1fr_1fr_1.2fr]">
            <div>
              <Link to="/" aria-label="Flex Group, accueil"><img src="/logo.png" alt="Flex Group" className="h-14 w-auto" /></Link>
              <p className="mt-5 max-w-xs text-[0.9375rem] leading-relaxed text-ink">{siteInfo.tagline}</p>
            </div>

            <nav aria-label="Domaines">
              <div className={heading}>Domaines</div>
              <ul>{domains.map((d) => <li key={d.id}><Link to="/services" className={linkCls}>{d.name}</Link></li>)}</ul>
            </nav>

            <nav aria-label="Entreprise">
              <div className={heading}>Entreprise</div>
              <ul>
                {mainLinks.map((l) => <li key={l.to}><Link to={l.to} className={linkCls}>{l.label}</Link></li>)}
                <li><Link to="/contact" className={linkCls}>Contact</Link></li>
              </ul>
            </nav>

            <div>
              <div className={heading}>Contact</div>
              <address className="not-italic text-[0.9375rem] leading-relaxed text-black">
                <p className="text-black">{siteInfo.address}</p>
                <a href={siteInfo.phoneHref} className="mt-3 block transition-colors hover:text-brand-dark">{siteInfo.phone}</a>
                <a href={`mailto:${siteInfo.email}`} className="block transition-colors hover:text-brand-dark">{siteInfo.email}</a>
              </address>
              <dl className="mt-5 space-y-1 text-sm text-ink">
                {siteInfo.hours.map((h) => (
                  <div key={h.day} className="flex justify-between gap-4 border-b border-line/70 py-1"><dt>{h.day}</dt><dd className="font-medium text-black">{h.time}</dd></div>
                ))}
              </dl>
            </div>
          </div>

          <div className="mt-14 flex flex-col gap-6 border-t border-line pt-8 md:flex-row md:items-center md:justify-between">
            <ul className="flex items-center gap-5">
              {socials.map(({ href, label, Icon }) => (
                <li key={label}>
                  <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="block text-charcoal transition-colors hover:text-brand-dark">
                    <Icon className="h-6 w-6" />
                  </a>
                </li>
              ))}
            </ul>
            <div className="text-xs leading-relaxed text-ink md:text-right">
              <p>© {new Date().getFullYear()} {siteInfo.name}. Tous droits réservés.</p>
              <p>{siteInfo.legal}</p>
              <p>Développé par <a href="https://upperz.africa" target="_blank" rel="noopener noreferrer" className="font-semibold text-charcoal underline decoration-brand underline-offset-4">Upperz</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
